var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Generated by `npm run icon`, don't modify this file
import React from 'react';
import Base from './_base';
const Eye = props => {
    const { className = null } = props, other = __rest(props, ["className"]);
    return (<Base viewBox="0 0 16 16" className={`cuk2-icon-eye ${className}`} {...other}>
      <g>
        <path d="M8 2.5c3.035 0 5.66 1.688 7.832 4.945a1 1 0 010 1.11C13.66 11.812 11.035 13.5 8 13.5S2.34 11.812.168 8.555a1 1 0 010-1.11C2.34 4.188 4.965 2.5 8 2.5zm0 1.51c-2.052 0-4.425 1.536-6.098 3.712L1.694 8l.216.289c1.535 1.99 3.854 3.542 5.704 3.699l.254.016.245.005c2.052 0 4.34-1.554 6.013-3.73L14.333 8l-.215-.288c-1.535-1.99-3.769-3.524-5.62-3.68l-.253-.017L8 4.01zM8 5.5a2.5 2.5 0 110 5 2.5 2.5 0 010-5zM8 7a1 1 0 100 2 1 1 0 000-2z" fillRule="evenodd"/>
      </g>
    </Base>);
};
export default Eye;
